module.exports = __webpack_public_path__ + "img/addr.f3ea61fc.png";